import { render, staticRenderFns } from "./TheSettingsStartsPrice.vue?vue&type=template&id=97c825b0&"
import script from "./TheSettingsStartsPrice.vue?vue&type=script&lang=js&"
export * from "./TheSettingsStartsPrice.vue?vue&type=script&lang=js&"
import style0 from "./TheSettingsStartsPrice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports